import { PartnerGroup } from "app/model/shared/transaction/partner";
import { BaseResponse } from "./internal/baseresponse";
import { CustomerSnsInfo } from 'app/model/shared/user/user';

export class CustomerSnsInfoResult extends BaseResponse {
    data: CustomerSnsInfo;
  }
  


// WEBPACK FOOTER //
// ./src/app/response/customersnsresult.ts